import { render, staticRenderFns } from "./StreamAmgPasses.vue?vue&type=template&id=8b6ea284&scoped=true"
import script from "./StreamAmgPasses.vue?vue&type=script&lang=js"
export * from "./StreamAmgPasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6ea284",
  null
  
)

export default component.exports